import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VersionupdateService } from '../../main-layout/versionupdate/versionupdate.service';
import { Utilityservice } from '../../utility/utilityservice.service';
import { BaseClass } from '../../utility/baseClass';


@Component({
  selector: 'app-versionupdatemodal',
  templateUrl: './versionupdatemodal.component.html',
  styleUrls: ['./versionupdatemodal.component.css']
})
export class VersionupdatemodalComponent extends BaseClass implements OnInit {
  myForm: FormGroup
  addForm: FormGroup
  maxDate = new Date();
  tableData: any[] = [];
  productList = [];
  versionList = [];
  categoryList = [];
  isDropdownOpen = false;
  isView: any;
  saveTitle = 'Save'
  isEdit: boolean = false;
  isAdd: boolean = false;
  versionId = null;
  dataDetails: any = {}
  CSRFToken = "";
  scriptid: null;
  sdlcid: 0;

  public validation_message = {
    version: [{ type: 'required', message: 'Version is required' }],
    category: [{ type: 'required', message: 'Category Type is required' }],
    product: [{ type: 'required', message: 'Product must be chosen' }],
    requirementid: [{ type: 'required', message: 'Requirement ID is required. Enter 0 if not known' }],
    feature: [
      { type: 'required', message: 'Feature name is required' },
      { type: 'placeholder', message: 'Enter Feature Name' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    towhom: [
      { type: 'required', message: 'To Whom is required' },
      { type: 'placeholder', message: 'Enter To whom' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    advantages: [
      { type: 'required', message: 'Advantages of Functionality is required' },
      { type: 'placeholder', message: 'Enter Advantages of Functionality' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    functionality: [
      { type: 'required', message: 'Functionality Description is required' },
      { type: 'placeholder', message: 'Enter Functionality Description' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    aversion: [{ type: 'required', message: 'Version is required' }],
    acategory: [{ type: 'required', message: 'Category Type is required' }],
    aproduct: [{ type: 'required', message: 'Product must be chosen' }],
    arequirementid: [{ type: 'required', message: 'Requirement ID is required. Enter 0 if not known' }],
    afeature: [
      { type: 'required', message: 'Feature name is required' },
      { type: 'placeholder', message: 'Enter Feature Name' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    atowhom: [
      { type: 'required', message: 'To Whom is required' },
      { type: 'placeholder', message: 'Enter To whom' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    aadvantages: [
      { type: 'required', message: 'Advantages of Functionality is required' },
      { type: 'placeholder', message: 'Enter Advantages of Functionality' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ],
    afunctionality: [
      { type: 'required', message: 'Functionality Description is required' },
      { type: 'placeholder', message: 'Enter Functionality Description' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
    ]
  }


  constructor(
    private versionupdateService: VersionupdateService,
    private utilityService: Utilityservice,
    public router: Router, private fb: FormBuilder,
    public override  injector: Injector,
    private el: ElementRef,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    this.maxDate.setDate(this.maxDate.getDate());
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.dataDetails = dataFromParent.datas
    }
    if (dataFromParent?.title == 'Add') {
      this.saveTitle = 'Add Version Update'
      this.isAdd = true;
      //        this.dataDetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getProductList();
    this.getVersionList();
    this.getCategoryList();
    this.getData()
  }
  getData() {
    if (this.isEdit) { this.patchValueForms(this.dataDetails) }
    if (this.isAdd) { this.patchValueAddForms() }
  }

  patchValueForms(data) {
    this.versionId = data[0].id;
    this.myForm.patchValue({ 'product': data[0].productid });
    this.myForm.patchValue({ 'version': data[0].version });
    this.myForm.patchValue({ 'category': data[0].versioncategoryid });
    this.myForm.patchValue({ 'releaseddate': data[0].releaseddate });
    this.myForm.patchValue({ 'requirementid': data[0].requirementid });
    this.myForm.patchValue({ 'feature': data[0].feature });
    this.myForm.patchValue({ 'advantages': data[0].advantageoffeature });
    this.myForm.patchValue({ 'towhom': data[0].towhom });
    this.myForm.patchValue({ 'functionality': data[0].usedfunctionality });
  }

  patchValueAddForms() {
    this.addForm.patchValue({ 'product': '' });
    this.addForm.patchValue({ 'version': '' });
    this.addForm.patchValue({ 'category': '' });
    this.addForm.patchValue({ 'releaseddate': '' });
    this.addForm.patchValue({ 'requirementid': '' });
    this.addForm.patchValue({ 'feature': '' });
    this.addForm.patchValue({ 'advantages': '' });
    this.addForm.patchValue({ 'towhom': '' });
    this.addForm.patchValue({ 'functionality': '' });
  }


  getProductList() {
    this.versionupdateService.getProducts().subscribe(res => {
      this.productList = res;
    })
  }
  getVersionList() {
    this.versionupdateService.getVersions().subscribe(res => {
      this.versionList = res;
    })
  }
  getCategoryList() {
    this.versionupdateService.getCategory().subscribe(res => {
      this.categoryList = res;
    })
  }

  dismiss() {
    Swal.fire({
      title: "Are you sure, you want to Close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }


  formInitiliaze() {
    this.myForm = this.fb.group({
      releaseddate: [''],
      version: ['', Validators.compose([Validators.required])],
      category: ['', Validators.compose([Validators.required])],
      product: ['', Validators.compose([Validators.required])],
      requirementid: ['', Validators.compose([Validators.required])],
      feature: ['', Validators.compose([Validators.required, Validators.maxLength(500)])],
      towhom: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      advantages: ['', Validators.compose([Validators.required, Validators.maxLength(1500)])],
      functionality: ['', Validators.compose([Validators.required, Validators.maxLength(5000)])]
    })

    this.addForm = this.fb.group({
      aversion: ['', Validators.compose([Validators.required])],
      acategory: ['', Validators.compose([Validators.required])],
      aproduct: ['', Validators.compose([Validators.required])],
      arequirementid: ['', Validators.compose([Validators.required])],
      afeature: ['', Validators.compose([Validators.required, Validators.maxLength(500)])],
      atowhom: ['', Validators.compose([Validators.required, Validators.maxLength(100)])],
      aadvantages: ['', Validators.compose([Validators.required, Validators.maxLength(1500)])],
      afunctionality: ['', Validators.compose([Validators.required, Validators.maxLength(5000)])]
    })
  }
  // Add New DBScript
  add() {
    if (this.addForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill up all the mandatory/required fields and then Save!',
        customClass: { icon: 'custom-skyblue-icon' },
        willClose: () => {
          this.validateAllFormFields(this.addForm, this.el);
          setTimeout(() => {
            const firstInvalidControl = document.querySelector('.ng-invalid') as HTMLElement | null;
            if (firstInvalidControl) {
              const focusable = firstInvalidControl.querySelector<HTMLElement>(
                'input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (focusable) { focusable.focus(); }
              else {
                firstInvalidControl.tabIndex = -1;
                firstInvalidControl.focus();
              }
            }
          }, 10);
        }
      });
    }
    else {
      const payload = {
        productid: this.addForm.get('aproduct').value,
        versionid: this.addForm.get('aversion').value,
        categoryid: this.addForm.get('acategory').value,
        feature: this.addForm.get('afeature').value,
        advantages: this.addForm.get('aadvantages').value,
        towhom: this.addForm.get('atowhom').value,
        functionality: this.addForm.get('afunctionality').value,
        requirementid: this.addForm.get('arequirementid').value,
        csrftoken: this.CSRFToken
      }
      Swal.fire({
        title: "Do you want to Add the Version Update?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`
      }).then((value) => {
        if (value.isConfirmed) {
          this.spinnerservice.show();
          this.versionupdateService.add(payload).subscribe((data: any) => {
            this.spinnerservice.hide();
            Swal.fire("Version Update is added successfully!", "", "success").then(() => {
              this.ref.close()
            });
          }, error => {
            this.spinnerservice.hide();
            Swal.fire(error.error.message, '', 'error').then(() => {
            });
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not Saved", "", "info")
        }
      });
    }
  }

  //Modify DB Script
  modify() {
    if (this.myForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill up all the mandatory/required fields and then Save!',
        customClass: { icon: 'custom-skyblue-icon' },
        willClose: () => {
          this.validateAllFormFields(this.myForm, this.el);
          setTimeout(() => {
            const firstInvalidControl = document.querySelector('.ng-invalid') as HTMLElement | null;
            if (firstInvalidControl) {
              const focusable = firstInvalidControl.querySelector<HTMLElement>(
                'input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (focusable) { focusable.focus(); }
              else {
                firstInvalidControl.tabIndex = -1;
                firstInvalidControl.focus();
              }
            }
          }, 10);
        }
      });
    }
    else {
      const payload = {

        productid: this.myForm.get('product').value,
        versionid: this.myForm.get('version').value,
        categoryid: this.myForm.get('category').value,
        feature: this.myForm.get('feature').value,
        advantages: this.myForm.get('advantages').value,
        towhom: this.myForm.get('towhom').value,
        functionality: this.myForm.get('functionality').value,
        releaseddate: moment(this.myForm.get('releaseddate').value).format('DD-MMM-YYYY'),
        requirementid: this.myForm.get('requirementid').value,
        id: this.versionId,
        csrftoken: this.CSRFToken
      }

      Swal.fire({
        title: "Do you want to Save the Changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`
      })
        .then((value) => {
          if (value.isConfirmed) {
            this.spinnerservice.show();
            this.versionupdateService.modify(payload).subscribe(() => {
              this.spinnerservice.hide();
              Swal.fire("Version Update is modified successfully!", "", "success").then(() => {
                this.ref.close()
              });
            }, error => {
              this.spinnerservice.hide();
              Swal.fire(error.error.message, '', 'error');
            });

          } else if (value.isDenied) {
            Swal.fire("Changes are not Saved", "", "info")
          }

        });
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityService.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })

  }
}
